import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Send me an email @ `}<a parentName="p" {...{
        "href": "mailto:Fredrik.widegren@gmail.com"
      }}>{`Fredrik.widegren@gmail.com`}</a>{` and we'll talk! `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      